module.exports = __webpack_public_path__ + "img/buck-logo.bb6119d7.svg";